import {
  createVehicleApi,
  deleteVehicleApi,
  getVehicleByIdApi,
  getVehicleListApi,
  getVehicleTypeApi,
  updateVehicleApi,
} from "../../helpers/backend_helper";

import {
  getVehicleList,
  errorMessages,
  vehicleById,
  vehicleByType,
  setLoading,
} from "./reducer";

export const getAllVehicleList = (currentPage, pageSize, searchText) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "read", value: true }));
    let response;
    response = getVehicleListApi(currentPage, pageSize, searchText);
    const data = await response;
    dispatch(getVehicleList(data));
    return true;
  } catch (error) {
    dispatch(errorMessages("Some thing went wrong, please try later"));
    return false;
  } finally {
    dispatch(setLoading({ type: "read", value: false }));

  }
};

export const getVehicleById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "getById", value: true }));
    let response;
    response = getVehicleByIdApi(id);
    const data = await response;
    dispatch(vehicleById(data));
    return true;
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return false;
  } finally {
    dispatch(setLoading({ type: "getById", value: false }));
  }
};

export const getVehicleType = () => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "vehicleType", value: true }));
    let response;
    response = getVehicleTypeApi();
    const data = await response;
    dispatch(vehicleByType(data));
    return true;
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return false;
  } finally {
    dispatch(setLoading({ type: "vehicleType", value: false }));
  }
};

export const createVehicle = (data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "create", value: true }));
    await createVehicleApi(data);
    return { success: true, message: "Vehicle Successfully Created" };
  } catch (error) {
    const errorMessage = error.response?.data?.errors || "Error creating vehicle";
    return { success: false, message: errorMessage };
  } finally {
    dispatch(setLoading({ type: "create", value: false }));
  }
};

export const updateVehicle = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "update", value: true }));
    let response;
    response = await updateVehicleApi(id, data);
    return { success: true, message: "Vehicle updated successfully!" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    return { success: false, message: errorMessage };;
  } finally {
    dispatch(setLoading({ type: "update", value: false }));
  }
};

export const deleteVehicle = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "delete", value: true }));
    await deleteVehicleApi(id);
    return { success: true, message: "Vehicle successfully deleted" };

  } catch (error) {
    const errorMessage = error.response?.data?.errors || "An error occurred";
    return { success: false, message: errorMessage };
  } finally {
    dispatch(setLoading({ type: "delete", value: false }));
  }
};